import React from "react";
// Common Components
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Local Components
import { Additional } from "./Additional";
// Requests
import { getFundNoRiskSellOrderTable, getFundNoRiskTable, NoRiskTradeInputDTO } from "src/Requests/fundNoRiskTask";

interface IProps {
  id:number;
}
const FundNoRiskTradeOrderTable: React.FC<IProps> = ({
  id

}) => {
  return (
    <TableTemplate
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          
          tableBoxClassName="!max-h-[800px]"
          
        />
      )}
      initialSearchParameters={ {taskId:id} as NoRiskTradeInputDTO} 
      getDataTable={getFundNoRiskSellOrderTable}
      
    />
  );
};

export default FundNoRiskTradeOrderTable;